'use strict';

define(['jquery', 'app'], function ($, app) {

  var _loginPage = {

    _emailRegex: new RegExp('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)+$'),

    _forgottenPasswordClickHandler: function _forgottenPasswordClickHandler() {
      var forgotEmail = document.getElementById('forgot-password');
      forgotEmail.value = document.getElementById('username').value;
      //tracking for opening forgotten password modal window
      app.publish('tracking/record', 'Login', 'Forgot Password', 'Trigger Modal');

      var forgotPasswordForm = document.getElementById('forgot-password-form');
      //open the window
      if ($().fancybox) {
        $.fancybox(forgotPasswordForm, {
          'closeBtn': false,
          'content': forgotPasswordForm.innerHTML,
          afterShow: function afterShow() {
            $('.fb-close').on('click', function (e) {
              e.preventDefault();
              $.fancybox.close(true);
            });
          }
        });
      }
    },

    _successCallbackHandler: function _successCallbackHandler(forgotPasswordForm, passwordSuccessText, passwordSuccess, customerEmail) {
      forgotPasswordForm.css('display', 'none');
      passwordSuccessText.append('<strong class="email"> ' + customerEmail + '</strong>');
      passwordSuccess.css('display', 'block');
    },

    _errorCallbackHandler: function _errorCallbackHandler(errorThrown, forgotPasswordForm, passwordError) {
      forgotPasswordForm.css('display', 'none');
      passwordError.css('display', 'block');
      app.publish('tracking/record', 'Login', 'Forgot Password', 'Error: ' + errorThrown);
    },

    _formSubmitHandler: function _formSubmitHandler(e) {
      var forgotPasswordForm = $('#forgot-password-form');
      var passwordSuccess = $('#password-success');
      var passwordSuccessText = passwordSuccess.find('p');
      var passwordError = $('#password-error');
      var passwordErrorBtn = passwordError.find('.loginCard_button');
      var passwordIncorrect = $('#password-incorrect');
      var passwordIncorrectBtn = passwordIncorrect.find('.loginCard_button');

      e.preventDefault();

      //get customer email to use in success message
      var customerEmail = $('#forgot-password').val();
      //email regex to test against
      if (_loginPage._emailRegex.test(customerEmail)) {
        //post form via ajax
        $.ajax({
          url: forgotPasswordForm.attr('action'),
          type: 'POST',
          data: forgotPasswordForm.serialize(),
          success: function success() {
            _loginPage._successCallbackHandler(forgotPasswordForm, passwordSuccessText, passwordSuccess, customerEmail);
          },
          error: function error(jXHR, textStatus, errorThrown) {
            _loginPage._errorCallbackHandler(errorThrown, forgotPasswordForm, passwordError);
          }
        });
      } else {
        //error message if incorrect email is entered
        forgotPasswordForm.css('display', 'none');
        passwordIncorrect.css('display', 'block');
        app.publish('tracking/record', 'Login', 'Forgot Password', 'Invalid Email');
      }

      $('.fancybox-close, .fancybox-overlay').on('click', function () {
        forgotPasswordForm.css('display', 'block');
        $('strong').remove('.email');
        passwordSuccess.css('display', 'none');
        passwordError.css('display', 'none');
        passwordIncorrect.css('display', 'none');
      });

      passwordIncorrectBtn.on('click', function () {
        forgotPasswordForm.css('display', 'block');
        passwordIncorrect.css('display', 'none');
      });

      passwordErrorBtn.on('click', function () {
        forgotPasswordForm.css('display', 'block');
        passwordError.css('display', 'none');
      });
    },

    _loadUsernameFromLocalStorage: function _loadUsernameFromLocalStorage(usernameInput) {
      if (localStorage.getItem('usernameEmail') !== null && usernameInput !== null) {
        usernameInput.value = localStorage.getItem('usernameEmail');
      }
    },

    _storeUsernameToLocalStorage: function _storeUsernameToLocalStorage(usernameInput) {
      if (usernameInput !== null) {
        app.element.on('change', function () {
          localStorage.setItem('usernameEmail', usernameInput.value);
        }, usernameInput);
      }
    },

    _setFocus: function _setFocus(usernameInput) {
      if (usernameInput !== null && usernameInput.value.length > 0) {
        usernameInput.focus();
      }
    },

    _trackForgotPasswordInteractions: function _trackForgotPasswordInteractions() {
      $('#forgot-password').on('change keyup paste click', function () {
        //tracking for interacting with email on forgotten password modal
        app.publish('tracking/record', 'Login', 'Forgot Password', 'Edit Email');
      });
    },

    _init: function _init() {
      var forgotPassword = document.getElementById('forgottenpassword');
      if (forgotPassword) {
        app.on('click', _loginPage._forgottenPasswordClickHandler, forgotPassword);
      }
      var usernameInput = document.getElementById('username');
      _loginPage._loadUsernameFromLocalStorage(usernameInput);
      _loginPage._storeUsernameToLocalStorage(usernameInput);
      _loginPage._setFocus(usernameInput);
      _loginPage._trackForgotPasswordInteractions();

      //forgotten password over ajax;
      if (window.siteObj.features.ajaxForgotPassword.show === true) {
        var forgotPasswordForm = $('#forgot-password-form');
        forgotPasswordForm.on('submit', function (e) {
          _loginPage._formSubmitHandler(e);
        });
      }
    }
  };

  _loginPage._init();
  return _loginPage;
});
//# sourceMappingURL=login-page.js.map
